var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 24,
    height: 24,
    transform: "translate(491 747)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perf",
    transform: "translate(-491 -747)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stars-regular",
    d: "M12.173,4.031,14.5,5l.967,2.328a.314.314,0,0,0,.562,0L17,5l2.326-.967a.313.313,0,0,0,0-.563L17,2.5,16.03.176A.306.306,0,0,0,15.75,0a.309.309,0,0,0-.281.176L14.5,2.5l-2.328.967a.314.314,0,0,0,0,.562ZM23.859,10.28,22,9.5l-.779-1.858A.245.245,0,0,0,21,7.5a.3.3,0,0,0-.223.141L20,9.5l-1.858.78a.247.247,0,0,0,0,.445L20,11.5l.779,1.858A.245.245,0,0,0,21,13.5a.3.3,0,0,0,.223-.14L22,11.5l1.857-.78A.247.247,0,0,0,24,10.5.236.236,0,0,0,23.859,10.28Zm-6.787,2.245-4.913-.716L9.966,7.345a1.069,1.069,0,0,0-.97-.6,1.05,1.05,0,0,0-.961.6l-2.2,4.425-4.912.755a1.077,1.077,0,0,0-.6,1.842l3.556,3.469-.8,4.9A1.045,1.045,0,0,0,4.1,24a1,1,0,0,0,.5-.127L9,21.559l4.394,2.315a1.077,1.077,0,0,0,1.137-.082,1.065,1.065,0,0,0,.427-1.05l-.839-4.905,3.559-3.469A1.081,1.081,0,0,0,17.072,12.525ZM11.7,17.053l.638,3.727L9,19.022,5.655,20.78,6.3,17.053,3.592,14.414l3.738-.545L9,10.491l1.669,3.38,3.738.545Z",
    transform: "translate(491 747)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerf);
export default __webpack_public_path__ + "static/media/perf.a052787a4daa7ede73214fca6e009f8c.svg";
export { ForwardRef as ReactComponent };